module.exports = __webpack_public_path__ + "static/media/pastanaga-small.7bb0d7b7.svg";